/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import * as yup from 'yup'

yup.setLocale({
  mixed: {
    required: 'GENERAL_FORM_FIELD_IS_REQUIRED_ERROR'
  },
  string: {
    max: 'FORM_VALIDATION_ERROR_MAX_LENGTH_IS_${max}'
  }
})

const ValidationSchema = () => {
  return yup.object().shape({
    id: yup.number().nullable(),
    name: yup
      .string()
      .trim()
      .max(500)
      .required()
      .default(() => ''),
    type: yup
      .string()
      .required()
      .default(() => 'NON_ETMF')
  })
}

export default ValidationSchema
